import { render } from "./GuaranteedIncomeModeller.vue?vue&type=template&id=2f72bb36&ts=true"
import script from "./GuaranteedIncomeModeller.vue?vue&type=script&lang=ts"
export * from "./GuaranteedIncomeModeller.vue?vue&type=script&lang=ts"

import "./GuaranteedIncomeModeller.vue?vue&type=style&index=0&id=2f72bb36&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__